import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.138.195a.667.667 0 1 0-.943.943l2.85 2.85A13 13 0 0 0 .08 7.685a.67.67 0 0 0-.009.613L.667 8c-.597.298-.596.299-.596.299v.002l.003.004.008.015a5 5 0 0 0 .127.236 13.781 13.781 0 0 0 1.888 2.567C3.403 12.514 5.4 14 8 14h.01a7.4 7.4 0 0 0 3.874-1.173l2.978 2.978a.667.667 0 0 0 .943-.943zm.578 8.276a11 11 0 0 1-.288-.47 11.6 11.6 0 0 1 2.563-3.067l1.7 1.7a2.667 2.667 0 0 0 3.676 3.675l1.547 1.548a6.05 6.05 0 0 1-2.92.81c-2.064-.003-3.731-1.184-4.924-2.456a12.5 12.5 0 0 1-1.354-1.74m4.901-.445q.003-.205.068-.398l1.687 1.687a1.333 1.333 0 0 1-1.755-1.289M6.752 3.476a5.4 5.4 0 0 1 1.246-.143H8c2.067 0 3.736 1.183 4.93 2.456A12.5 12.5 0 0 1 14.572 8a11.7 11.7 0 0 1-1.189 1.698.667.667 0 0 0 1.02.859 13 13 0 0 0 1.518-2.242.67.67 0 0 0 .009-.612L15.333 8c.597-.298.596-.3.596-.3l-.003-.005-.008-.015-.026-.052-.101-.184a13.784 13.784 0 0 0-1.888-2.567C12.597 3.484 10.6 2 8.001 2a6.8 6.8 0 0 0-1.553.177.667.667 0 0 0 .304 1.299m7.98 4.813-.019-.037a7 7 0 0 0-.141-.254l.082.148zm0 0 .005.008v.001L15.333 8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })